/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './SupportMain.style';

import SupportForm from './SupportForm';
import messages from 'src/shared/app/support/l10n/supportL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import TopBar from 'src/shared/app/nav/component/top-bar/TopBar';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { homeRoute } from 'src/shared/app/base/route/setting/routeSettings';

const useStyles = createUseStyles(styles);

const SupportMain = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [homePath] = useRoutes(homeRoute);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <DocumentTitle>{intl.formatMessage(messages.title)}</DocumentTitle>
      <div className={classes.root}>
        <ZIndexTopBar>
          <TopBar
            title={intl.formatMessage(messages.supportTitle)}
            backTo={homePath}
          />
        </ZIndexTopBar>
        <SupportForm />
      </div>
    </React.Fragment>
  );
};

export default compose(React.memo)(SupportMain);
